module.exports = __webpack_public_path__ + "img/new.be703474.svg";